import React from 'react';

export const Instructions = () => {

}